import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import BoldTypography from "components/BoldTypography";
import GridBlock from "components/GridBlock";
import IconButton from "components/button/IconButton";
import WorkableIconButton from "components/button/WorkableIconButton";
import SimpleSelect from "components/SimpleSelect";
import {PurchasingGroupStatus, PurchasingGroupStatusLabel} from "../constants/PurchasingGroupStatus";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    state: {
        width: 200,
    },
    search: {
        width: 350,
    }
}));

const EMPTY_SEARCH_OBJECT = {state: "", search: ''}
const MAX_SEARCH_LENGTH = 100;

const decisionsList = [{label: Tr('procedure_status_0'), value: ""}, ...Object.keys(PurchasingGroupStatus).map(key => ({
    label: PurchasingGroupStatusLabel(key),
    value: key
}))];

function PurchasingGroupSearch(
    {
        searchInProgress,
        doSearch
    }) {

    const classes = useStyle();
    const [value, setValue] = useState({...EMPTY_SEARCH_OBJECT});
    const [submitState, setSubmitState] = useState(0);

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => value[k])
                .reduce((a, k) => ({...a, [k]: value[k]}), {});
            doSearch(valueFiltered);
        }
        // eslint-disable-next-line
    }, [submitState]);

    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleSubmit = () => {
        setSubmitState(x => x + 1)
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit()
        }
    }

    return (
        <>
            <BoldTypography>{Tr('search_box')}</BoldTypography>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
            >

                <TextField
                    className={classes.search}
                    label={Tr('search')}
                    onChange={e => handleChange('search', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.search}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />


                <SimpleSelect
                    className={classes.state}
                    label={Tr('status')}
                    items={decisionsList}
                    value={value.state}
                    onChange={(e) => {
                        handleChange("state", e);
                        handleSubmit();
                    }}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={() => {
                        setValue(EMPTY_SEARCH_OBJECT);
                        handleSubmit()
                    }}/>
                </div>
            </GridBlock>
        </>
    )
}

PurchasingGroupSearch.propTypes = {
    doSearch: PropTypes.func.isRequired,
    searchInProgress: PropTypes.bool
}


export default PurchasingGroupSearch;